import { application } from '@/controllers/application'

import Tools_ImageDescriptionDropzoneController from '@/controllers/tools/image_description_dropzone_controller'
import Tools_CopyController from '@/controllers/tools/copy_controller'
import Tools_CsvDownloadController from '@/controllers/tools/csv_download_controller'
application.register('image-description-dropzone', Tools_ImageDescriptionDropzoneController)
application.register('tool-copy', Tools_CopyController)
application.register('tool-csv-download', Tools_CsvDownloadController)
